const EMAIL_REGEX = /^[-!#$%&'*+/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-?\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
const BEFORE_AT_MAX_LENGTH = 64;
const DOMAINS_PARTS_MAX_LENGTH = 63;
// forked from https://github.com/Sembiance/email-validator
export default function validate(email) {
    const isAtLeastAMail = email && email.length < 254 && EMAIL_REGEX.test(email);

    if (!isAtLeastAMail) {
        return false;
    }

    // Further checking of some things regex can't handle
    const parts = email.split('@');

    if (parts[0].length > BEFORE_AT_MAX_LENGTH) {
        return false;
    }

    const domainParts = parts[1].split('.');

    if (domainParts.some(part => part.length > DOMAINS_PARTS_MAX_LENGTH)) {
        return false;
    }

    return true;
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/misc/validate-email.js